/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDataUploadStatus } from './InternalApiDataUploadStatus';
import {
    InternalApiDataUploadStatusFromJSON,
    InternalApiDataUploadStatusFromJSONTyped,
    InternalApiDataUploadStatusToJSON,
    InternalApiDataUploadStatusToJSONTyped,
} from './InternalApiDataUploadStatus';
import type { InternalApiDataUploadError } from './InternalApiDataUploadError';
import {
    InternalApiDataUploadErrorFromJSON,
    InternalApiDataUploadErrorFromJSONTyped,
    InternalApiDataUploadErrorToJSON,
    InternalApiDataUploadErrorToJSONTyped,
} from './InternalApiDataUploadError';

/**
 * a Data upload status history record
 * @export
 * @interface InternalApiDataUploadStatusHistoryRecord
 */
export interface InternalApiDataUploadStatusHistoryRecord {
    /**
     * 
     * @type {InternalApiDataUploadStatus}
     * @memberof InternalApiDataUploadStatusHistoryRecord
     */
    status: InternalApiDataUploadStatus;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiDataUploadStatusHistoryRecord
     */
    createdTime: Date;
    /**
     * 
     * @type {Array<InternalApiDataUploadError>}
     * @memberof InternalApiDataUploadStatusHistoryRecord
     */
    errors?: Array<InternalApiDataUploadError>;
}



/**
 * Check if a given object implements the InternalApiDataUploadStatusHistoryRecord interface.
 */
export function instanceOfInternalApiDataUploadStatusHistoryRecord(value: object): value is InternalApiDataUploadStatusHistoryRecord {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiDataUploadStatusHistoryRecordFromJSON(json: any): InternalApiDataUploadStatusHistoryRecord {
    return InternalApiDataUploadStatusHistoryRecordFromJSONTyped(json, false);
}

export function InternalApiDataUploadStatusHistoryRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDataUploadStatusHistoryRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'status': InternalApiDataUploadStatusFromJSON(json['status']),
        'createdTime': (new Date(json['createdTime'])),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(InternalApiDataUploadErrorFromJSON)),
    };
}

export function InternalApiDataUploadStatusHistoryRecordToJSON(json: any): InternalApiDataUploadStatusHistoryRecord {
    return InternalApiDataUploadStatusHistoryRecordToJSONTyped(json, false);
}

export function InternalApiDataUploadStatusHistoryRecordToJSONTyped(value?: InternalApiDataUploadStatusHistoryRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': InternalApiDataUploadStatusToJSON(value['status']),
        'createdTime': value['createdTime'].toISOString(),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(InternalApiDataUploadErrorToJSON)),
    };
}

